import i18n from '../../i18n';

export const MESSAGES = {
  FETCH_NOTIFICATIONS: {
    ERROR: {
      401: i18n.t('You are not authorized to fetch the notifications.'),
      403: i18n.t('You are not allowed to fetch the notifications.'),
      404: i18n.t('The notifications you are trying to fetch do not exist.'),
      500: i18n.t('An error occurred fetching the notifications. (500)'),
      default: i18n.t('An error occurred fetching the notifications.')
    }
  },
  DELETE_NOTIFICATION: {
    ERROR: {
      401: i18n.t('You are not authorized to delete the notification.'),
      403: i18n.t('You are not allowed to delete the notification.'),
      404: i18n.t('The notification you are trying to delete does not exist.'),
      500: i18n.t('An error occurred deleting the notification.'),
      default: i18n.t('An error occurred deleting the notification.')
    },
    SUCCESS: {
      200: i18n.t('Notification deleted successfully.')
    }
  },
  READ_NOTIFICATION: {
    ERROR: {
      401: i18n.t('You are not authorized to read the notification.'),
      403: i18n.t('You are not allowed to read the notification.'),
      404: i18n.t('The notification you are trying to read does not exist.'),
      500: i18n.t('An error occurred reading the notification.'),
      default: i18n.t('An error occurred reading the notification.')
    },
    SUCCESS: {
      200: i18n.t('Notification read successfully.')
    }
  }
};

